import { environment } from '../../../../environments/environment';

//* Env Details
const base = environment.baseUrl;
const subDomainSuffix = environment.subDomainSuffix;

//* Env Urls
export const netIncomeUrl = `${base}/reporting${subDomainSuffix}/employeeportal/employee`;
export const profileUrl = `${base}/employee${subDomainSuffix}/employee`;
export const paystubsCollectionUrl = `${base}/reporting${subDomainSuffix}/employeeportal/paystubsyears`;
export const paystubDetailsUrl = `${base}/reporting${subDomainSuffix}/employeeportal/paystub`;
export const paystubDownloadUrl = `${base}/reporting${subDomainSuffix}/employeeportal/paystubdownload`;
export const taxFormsUrl = `${base}/reporting${subDomainSuffix}/employeeportal/taxforms`;
export const taxFormDownloadUrl = `${base}/reporting${subDomainSuffix}/employeeportal/taxformdownload`;
export const taxFormsNoticeUrl = `${base}/reporting${subDomainSuffix}/employeeportal/taxformsnotice`;
export const changePasswordUrl = `${base}/employee${subDomainSuffix}/employee/changepassword`;
export const passwordPolicyUrl = `${base}/user${subDomainSuffix}/password-policy`;
export const tipsFormsDisplayUrl = `${base}/reporting${subDomainSuffix}/employeeportal/tipsformsdisplay`;
export const tipFormDownloadUrl = `${base}/reporting${subDomainSuffix}/employeeportal/tipformdownload`;
export const userContextUrl = `${base}/reporting${subDomainSuffix}/employeeportal/usercontext`;
export const updateUserDetails = `${base}/employee${subDomainSuffix}/employee/updateuserdetails`;
export const mfaPhoneNumberUrl = `${base}/employee${subDomainSuffix}/employee/mfaphone`; //`http://localhost:18251/EmployeeService/employee/mfaphone`;
export const phoneUpdateOtpUrl = `${base}/employee${subDomainSuffix}/employee/phoneupdateotp`;
export const validateOtpUrl = `${base}/employee${subDomainSuffix}/employee/processotp`;
export const partnerCodeThemeUrl = `${base}/employee${subDomainSuffix}/employee/gettheminginfo`;
export const personalInfoUpdateUrl = `${base}/employee${subDomainSuffix}/employee/editpersonalinfo`;
export const getBclStatus = `${base}/employee${subDomainSuffix}/employee/BclStatus`;
